import React from "react";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import _ from "underscore";
import {filterLineItems, getImageSize} from "../../common/utils";
import config from "../../../config";
import Currency from "../../common/Currency";
import InternationalCurrency from "../../common/InternationalCurrency";

class PersonalizedCartModule extends React.Component {
    render() {
        const {cart_count, checkout, isInternational, selectedCountry} = this.props;
        const {lineItems} = checkout;
        const line_items_without_clyde = filterLineItems(lineItems);
        const cart_limit = 5;

        return (
            <div className="personalization__returning-user-cart">
                <div className="homepage-personalization__title">
                    Don't leave behind
                </div>
                <div className="returning-user-cart__subtitle">
                    You have {cart_count > cart_limit ? `${cart_limit}+` : cart_count} item{cart_count > 1 ? "s" : ""} waiting in your cart.
                </div>
                {line_items_without_clyde &&
                <div className="returning-user-cart__line-items">
                    {_.last(_.map(line_items_without_clyde, (lineItem, idx) => {
                        const item_variant = lineItem.variant;
                        const item_available = item_variant.available;
                        const item_product = item_variant.product;
                        const item_condition = item_product && item_product.condition && item_product.condition.value;
                        const item_quantity = parseInt(lineItem.quantity);
                        const item_link = item_variant.product.handle;

                        return (
                            <a
                                className="returning-user-cart__line-item"
                                key={idx}
                                href={`${config.host_rebag_shop}/products/${item_link}`}
                            >
                                <div className="returning-user-cart__line-items-thumb">
                                    <Image
                                        src={item_variant.image && item_variant.image.src ? getImageSize(item_variant.image.src) : config.PLACE_HOLDER}
                                        alt={lineItem.title}
                                        title={lineItem.title}
                                    />
                                </div>
                                <div className="returning-user-cart__line-items-info">
                                    <div className="returning-user-cart__line-items-title">
                                        <strong>{item_product.vendor}</strong> {lineItem.title}
                                    </div>
                                    {item_available && item_condition &&
                                    <div className="returning-user-cart__line-items-condition">
                                        Condition: {item_condition}
                                    </div>
                                    }
                                </div>
                                <div className="returning-user-cart__line-items-price">
                                    {isInternational ?
                                        < InternationalCurrency value={parseFloat(item_variant.priceV2.amount)*item_quantity} currencySymbol={selectedCountry.currency.symbol}/>
                                        :
                                        <Currency value={parseFloat(item_variant.priceV2.amount)*item_quantity}/>
                                    }
                                </div>
                            </a>
                        )
                    }), cart_limit)}
                </div>
                }
                <div className="returning-user-cart__cta-container">
                    <Button
                        className="rbg-btn--link returning-user-cart__cta"
                        variant="link"
                        onClick={() => this.props.openShopifyCart(false)}
                    >
                        View Cart >
                    </Button>
                </div>
            </div>
        )
    }
}

export default PersonalizedCartModule;